import { API_ROOT } from '../../config';
import { ssFetchJSON } from '../../modules/ssFetch';

export type AppointmentRequestResponse = {
  totals: {
    balance_remaining: string;
    booking_fee: string;
    deposit_due: string | null;
    deposit_paid: string | null;
  };
  metadata: {
    booking_fee_required: boolean;
    deposit_required: boolean;
  };
};

type AppointmentRequestParams = {
  appointment_date: string;
  booking_fee_type: unknown;
  start_time: string;
  discount_code?: string;
  reward_id: number;
  service_list: number[];
  smart_price_source?: string | number;
  smart_priced?: boolean;
};

// AppointmentRequestSerializer on backend
export const getAppointmentRequest = (
  providerId: number,
  params: AppointmentRequestParams,
) => {
  const url = new URL(`/api/v1/appointment-request/${providerId}`, API_ROOT);

  return ssFetchJSON<AppointmentRequestResponse>(
    url.toString(),
    {
      method: 'POST',
      body: params,
    },
  );
};
